import { LitElement, html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("sb-multi-select-filter")
export class SbMultiSelectFilter extends LitElement {
  @property({ type: Array }) options: { value: string; label: string }[] = [];
  @property({ type: Array }) selected: string[] = [];
  @property({ type: String }) placeholder = "Filter…";
  @property({ type: String }) label = "Filter";

  private _handleToggle(value: string) {
    const newSelected = this.selected.includes(value)
      ? this.selected.filter((v) => v !== value)
      : [...this.selected, value];
    this.dispatchEvent(
      new CustomEvent("change", {
        detail: { selected: newSelected },
        bubbles: true,
        composed: true,
      }),
    );
  }

  render() {
    const selectedLabels = this.options
      .filter((opt) => this.selected.includes(opt.value))
      .map((opt) => opt.label)
      .join(", ");
    const displayText = selectedLabels || this.placeholder;

    return html`
      <rtg-dropdown-menu>
        <rtg-dropdown-menu-trigger as-child>
          <rtg-button variant="outline" size="default">
            <div class="sb-flex sb-gap-2">
              ${this.label}
              ${this.selected.length
                ? html`<rtg-badge variant="default"
                    >${this.selected.length}</rtg-badge
                  >`
                : nothing}
            </div>
          </rtg-button>
        </rtg-dropdown-menu-trigger>
        <rtg-dropdown-menu-content>
          <rtg-dropdown-menu-group heading=${`Filter by ${this.label}`}>
            <rtg-dropdown-menu-separator></rtg-dropdown-menu-separator>
            ${this.options.map(
              (opt) => html`
                <rtg-dropdown-menu-item
                  @click=${() => this._handleToggle(opt.value)}
                >
                  <rtg-checkbox
                    .checked=${this.selected.includes(opt.value)}
                    @click=${(e: Event) => e.stopPropagation()}
                    @change=${(e: Event) => e.stopPropagation()}
                  ></rtg-checkbox>
                  <span>${opt.label}</span>
                </rtg-dropdown-menu-item>
              `,
            )}
          </rtg-dropdown-menu-group>
        </rtg-dropdown-menu-content>
      </rtg-dropdown-menu>
    `;
  }

  createRenderRoot() {
    return this;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "sb-multi-select-filter": SbMultiSelectFilter;
  }
}
